/* ==========================================================================
 *  Function: Basket process
 * ======================================================================= */
function fn_components_basket_process(){
	if ($( '.js-submit-basket' ).length){
		var valid = false;
		$( '.js-submit-basket' ).on( 'click' , function(e){
			// e.preventDefault();
			var inst = $(this);
			var thisTab = inst.closest( '.js-tabs-item' );

			$( '.form-error' ).removeClass( 'form-error' );

			thisTab.find( '.js-validate' ).each(function( index ) {
				if ($(this).val().length > 0){
					valid = true;
				} else {
					$(this).closest( '.form-line' ).addClass( 'form-error' );
					valid = false;
					return false;
				}
			});

			if (valid){
				thisTab.removeClass( class_active ).next().addClass( class_active );
				return false;
			} 

		});
	}
}